/**
 * 已發布行程更新公開版本的使用者文案。技術 key 保留英文，畫面不出現工程詞。
 */

export const publicationRefreshMessagesZhTW = {
  'travel.publication.section.title': '公開旅程',
  'travel.publication.section.loading': '載入公開設定…',
  'travel.publication.section.reload': '重新載入公開設定',
  'travel.publication.section.status.NO_PUBLICATION': '這趟旅程目前尚未公開。',
  'travel.publication.section.status.UNKNOWN': '公開狀態無法辨識。目前無法調整公開設定。',
  'travel.publication.section.status.REMOVED': '這趟旅程的公開設定已移除，無法再次公開。',
  'travel.publication.section.status.UNPUBLISHED': '這趟旅程目前已停止分享。',
  'travel.publication.section.status.DRAFT': '公開設定尚未完成。',
  'travel.publication.section.status.PUBLIC': '這趟旅程目前公開中。',
  'travel.publication.section.status.PUBLISHED': '這趟旅程已發布，但尚未設為公開可見。',
  'travel.publication.section.visibility.notSet': '尚未設定可見對象',
  'travel.publication.section.visibility.unknown': '可見對象無法辨識',
  'travel.publication.section.visibility.current': '目前可見對象：{label}',
  'travel.publication.section.visibility.label.PRIVATE': '僅自己',
  'travel.publication.section.visibility.label.FOLLOWERS': '追蹤者',
  'travel.publication.section.visibility.label.PUBLIC': '所有人',
  'travel.publication.section.action.MAKE_PUBLIC': '公開旅程',
  'travel.publication.section.action.REPUBLISH': '重新公開',
  'travel.publication.section.action.SET_PUBLIC': '設為公開',
  'travel.publication.section.action.UNPUBLISH': '停止分享',
  'travel.publication.section.confirmAction.MAKE_PUBLIC': '確認公開旅程',
  'travel.publication.section.confirmAction.REPUBLISH': '確認重新公開',
  'travel.publication.section.confirmAction.SET_PUBLIC': '確認設為公開',
  'travel.publication.section.confirmAction.UNPUBLISH': '確認停止分享',
  'travel.publication.section.confirm.publish.title': '確認發布這趟行程？',
  'travel.publication.section.confirm.publish.body': '發布後，符合可見對象的旅人可以查看這趟行程。',
  'travel.publication.section.confirm.republish.title': '重新發布這趟行程？',
  'travel.publication.section.confirm.republish.body': '重新發布後，其他人會看到你目前編輯中的最新內容。',
  'travel.publication.section.confirm.unpublish.title': '確認停止分享？',
  'travel.publication.section.cancelledHint': '已取消的旅程無法公開。',
  'travel.publication.section.error.not-found': '找不到公開設定。',
  'travel.publication.section.error.journey-not-found': '找不到這趟旅程。',
  'travel.publication.section.error.forbidden': '你沒有權限調整這趟旅程的公開設定。',
  'travel.publication.section.error.conflict': '公開設定剛剛有新的變更，已重新載入最新狀態。',
  'travel.publication.section.error.already-exists': '這趟旅程已有公開設定，已重新載入最新狀態。',
  'travel.publication.section.error.lifecycle-not-writable': '目前旅程狀態無法調整公開設定。',
  'travel.publication.section.error.invalid-lifecycle': '目前公開狀態無法執行這個操作。',
  'travel.publication.section.error.ownership-drift': '旅程擁有者資料已變更，請重新整理後再試。',
  'travel.publication.section.error.day-missing-place': '每一天都需要至少一個有效地點才能分享。請先補上缺少地點的日子。',
  'travel.publication.section.error.validation': '公開設定資料不正確。',
  'travel.publication.section.error.generic': '公開設定暫時無法完成。',
  'travel.publication.refresh.unchanged': '公開版本已是最新',
  'travel.publication.refresh.changed': '有尚未公開的變更',
  'travel.publication.refresh.changedHint': '目前公開頁面仍顯示上一次發布的內容。',
  'travel.publication.refresh.unknown': '尚未建立公開版本的內容基準。更新後即可確認公開內容狀態。',
  'travel.publication.refresh.blocked': '尚有項目需要處理，完成後才能更新公開版本',
  'travel.publication.refresh.cta': '更新公開版本',
  'travel.publication.refresh.ctaUnknown': '確認並更新公開版本',
  'travel.publication.refresh.view': '查看目前公開版本',
  'travel.publication.refresh.viewUnavailable': '目前的分享範圍無法開啟公開頁面',
  'travel.publication.refresh.dialogTitle': '更新公開版本？',
  'travel.publication.refresh.dialogPrevious': '目前公開頁面仍顯示上一個已發布版本。',
  'travel.publication.refresh.dialogNext': '更新後，公開頁面會改用目前的行程內容。',
  'travel.publication.refresh.dialogLink': '已分享的公開連結與揪團仍使用相同連結。',
  'travel.publication.refresh.dialogCopy': '新的複製與分享卡片會讀取更新後的公開版本。',
  'travel.publication.refresh.dialogFailure': '更新失敗時原本公開版本不受影響。',
  'travel.publication.refresh.cancel': '取消',
  'travel.publication.refresh.pending': '正在更新公開版本…',
  'travel.publication.refresh.successChanged': '公開版本已更新',
  'travel.publication.refresh.successNoOp': '公開版本已是最新',
  'travel.publication.refresh.planningChanged': '你的修改尚未更新到公開版本',
  'travel.publication.refresh.planningUnknown': '尚未確認公開內容是否與目前行程一致。',
  'travel.publication.refresh.manage': '前往公開設定',
  'travel.publication.refresh.reason.day': '某一天尚未安排有效地點',
  'travel.publication.refresh.reason.customLocation': '自訂地點目前無法公開',
  'travel.publication.refresh.reason.state': '行程狀態不允許更新',
  'travel.publication.refresh.reason.changed': '公開版本狀態已改變',
  'travel.publication.refresh.reason.reload': '請重新載入最新資料',
  'travel.publication.refresh.reason.generic': '尚有項目需要處理，完成後才能更新公開版本',
  'travel.publication.refresh.error.invalid': '這次更新的內容不正確，請重新載入後再試。',
  'travel.publication.refresh.error.forbidden': '你沒有更新此行程公開版本的權限',
  'travel.publication.refresh.error.notFound': '找不到可更新的公開版本。',
  'travel.publication.refresh.error.stale': '行程已在其他地方更新，請重新載入後再試',
  'travel.publication.refresh.error.lifecycle': '目前的行程或公開版本狀態無法更新',
  'travel.publication.refresh.error.concurrent': '公開版本正在更新，請稍後重新載入',
  'travel.publication.refresh.error.day': '每一天都需要有效地點後才能更新公開版本。',
  'travel.publication.refresh.error.customLocation': '此行程包含尚未公開的自訂地點，請先將地點設為公開或更換地點。',
  'travel.publication.refresh.error.eligibility': '目前的行程內容還不能更新到公開版本。',
  'travel.publication.refresh.error.rate': '操作過於頻繁，請稍後再試',
  'travel.publication.refresh.error.generic': '目前無法更新公開版本，原本的公開內容仍會保留',
  'travel.publication.refresh.reload': '重新載入',
  'travel.publication.refresh.retry': '再試一次',
  'travel.publication.refresh.versionsMissing': '請重新載入最新資料',
  'travel.publication.unpublish.body': '公開頁面將暫時無法查看。已分享的卡片可能顯示無法查看。之後重新公開仍使用同一個公開連結。',
};

export const publicationRefreshMessagesZhCN = {
  'travel.publication.section.title': '公开旅程',
  'travel.publication.section.loading': '加载公开设置…',
  'travel.publication.section.reload': '重新加载公开设置',
  'travel.publication.section.status.NO_PUBLICATION': '这趟旅程目前尚未公开。',
  'travel.publication.section.status.UNKNOWN': '公开状态无法识别。目前无法调整公开设置。',
  'travel.publication.section.status.REMOVED': '这趟旅程的公开设置已移除，无法再次公开。',
  'travel.publication.section.status.UNPUBLISHED': '这趟旅程目前已停止分享。',
  'travel.publication.section.status.DRAFT': '公开设置尚未完成。',
  'travel.publication.section.status.PUBLIC': '这趟旅程目前公开中。',
  'travel.publication.section.status.PUBLISHED': '这趟旅程已发布，但尚未设为公开可见。',
  'travel.publication.section.visibility.notSet': '尚未设置可见对象',
  'travel.publication.section.visibility.unknown': '可见对象无法识别',
  'travel.publication.section.visibility.current': '目前可见对象：{label}',
  'travel.publication.section.visibility.label.PRIVATE': '仅自己',
  'travel.publication.section.visibility.label.FOLLOWERS': '关注者',
  'travel.publication.section.visibility.label.PUBLIC': '所有人',
  'travel.publication.section.action.MAKE_PUBLIC': '公开旅程',
  'travel.publication.section.action.REPUBLISH': '重新公开',
  'travel.publication.section.action.SET_PUBLIC': '设为公开',
  'travel.publication.section.action.UNPUBLISH': '停止分享',
  'travel.publication.section.confirmAction.MAKE_PUBLIC': '确认公开旅程',
  'travel.publication.section.confirmAction.REPUBLISH': '确认重新公开',
  'travel.publication.section.confirmAction.SET_PUBLIC': '确认设为公开',
  'travel.publication.section.confirmAction.UNPUBLISH': '确认停止分享',
  'travel.publication.section.confirm.publish.title': '确认发布这趟行程？',
  'travel.publication.section.confirm.publish.body': '发布后，符合可见对象的旅人可以查看这趟行程。',
  'travel.publication.section.confirm.republish.title': '重新发布这趟行程？',
  'travel.publication.section.confirm.republish.body': '重新发布后，其他人会看到你目前编辑中的最新内容。',
  'travel.publication.section.confirm.unpublish.title': '确认停止分享？',
  'travel.publication.section.cancelledHint': '已取消的旅程无法公开。',
  'travel.publication.section.error.not-found': '找不到公开设置。',
  'travel.publication.section.error.journey-not-found': '找不到这趟旅程。',
  'travel.publication.section.error.forbidden': '你没有权限调整这趟旅程的公开设置。',
  'travel.publication.section.error.conflict': '公开设置刚刚有新的变更，已重新加载最新状态。',
  'travel.publication.section.error.already-exists': '这趟旅程已有公开设置，已重新加载最新状态。',
  'travel.publication.section.error.lifecycle-not-writable': '目前旅程状态无法调整公开设置。',
  'travel.publication.section.error.invalid-lifecycle': '目前公开状态无法执行这个操作。',
  'travel.publication.section.error.ownership-drift': '旅程拥有者资料已变更，请刷新后再试。',
  'travel.publication.section.error.day-missing-place': '每一天都需要至少一个有效地点才能分享。请先补上缺少地点的日子。',
  'travel.publication.section.error.validation': '公开设置数据不正确。',
  'travel.publication.section.error.generic': '公开设置暂时无法完成。',
  'travel.publication.refresh.unchanged': '公开版本已是最新',
  'travel.publication.refresh.changed': '有尚未公开的变更',
  'travel.publication.refresh.changedHint': '目前公开页面仍显示上一次发布的内容。',
  'travel.publication.refresh.unknown': '尚未建立公开版本的内容基准。更新后即可确认公开内容状态。',
  'travel.publication.refresh.blocked': '尚有项目需要处理，完成后才能更新公开版本',
  'travel.publication.refresh.cta': '更新公开版本',
  'travel.publication.refresh.ctaUnknown': '确认并更新公开版本',
  'travel.publication.refresh.view': '查看目前公开版本',
  'travel.publication.refresh.viewUnavailable': '目前的分享范围无法打开公开页面',
  'travel.publication.refresh.dialogTitle': '更新公开版本？',
  'travel.publication.refresh.dialogPrevious': '目前公开页面仍显示上一个已发布版本。',
  'travel.publication.refresh.dialogNext': '更新后，公开页面会改用目前的行程内容。',
  'travel.publication.refresh.dialogLink': '已分享的公开链接与结伴仍使用相同链接。',
  'travel.publication.refresh.dialogCopy': '新的复制与分享卡片会读取更新后的公开版本。',
  'travel.publication.refresh.dialogFailure': '更新失败时原本公开版本不受影响。',
  'travel.publication.refresh.cancel': '取消',
  'travel.publication.refresh.pending': '正在更新公开版本…',
  'travel.publication.refresh.successChanged': '公开版本已更新',
  'travel.publication.refresh.successNoOp': '公开版本已是最新',
  'travel.publication.refresh.planningChanged': '你的修改尚未更新到公开版本',
  'travel.publication.refresh.planningUnknown': '尚未确认公开内容是否与目前行程一致。',
  'travel.publication.refresh.manage': '前往公开设置',
  'travel.publication.refresh.reason.day': '某一天尚未安排有效地点',
  'travel.publication.refresh.reason.customLocation': '自定义地点目前无法公开',
  'travel.publication.refresh.reason.state': '行程状态不允许更新',
  'travel.publication.refresh.reason.changed': '公开版本状态已改变',
  'travel.publication.refresh.reason.reload': '请重新加载最新数据',
  'travel.publication.refresh.reason.generic': '尚有项目需要处理，完成后才能更新公开版本',
  'travel.publication.refresh.error.invalid': '这次更新的内容不正确，请重新加载后再试。',
  'travel.publication.refresh.error.forbidden': '你没有更新此行程公开版本的权限',
  'travel.publication.refresh.error.notFound': '找不到可更新的公开版本。',
  'travel.publication.refresh.error.stale': '行程已在其他地方更新，请重新加载后再试',
  'travel.publication.refresh.error.lifecycle': '目前的行程或公开版本状态无法更新',
  'travel.publication.refresh.error.concurrent': '公开版本正在更新，请稍后重新加载',
  'travel.publication.refresh.error.day': '每一天都需要有效地点后才能更新公开版本。',
  'travel.publication.refresh.error.customLocation': '此行程包含尚未公开的自定义地点，请先将地点设为公开或更换地点。',
  'travel.publication.refresh.error.eligibility': '目前的行程内容还不能更新到公开版本。',
  'travel.publication.refresh.error.rate': '操作过于频繁，请稍后再试',
  'travel.publication.refresh.error.generic': '目前无法更新公开版本，原本的公开内容仍会保留',
  'travel.publication.refresh.reload': '重新加载',
  'travel.publication.refresh.retry': '再试一次',
  'travel.publication.refresh.versionsMissing': '请重新加载最新数据',
  'travel.publication.unpublish.body': '公开页面将暂时无法查看。已分享的卡片可能显示无法查看。之后重新公开仍使用同一个公开链接。',
};

export const publicationRefreshMessagesEnUS = {
  'travel.publication.section.title': 'Public journey',
  'travel.publication.section.loading': 'Loading sharing settings…',
  'travel.publication.section.reload': 'Reload sharing settings',
  'travel.publication.section.status.NO_PUBLICATION': 'This trip isn’t public yet.',
  'travel.publication.section.status.UNKNOWN': 'The sharing status can’t be determined, so settings can’t be changed right now.',
  'travel.publication.section.status.REMOVED': 'Sharing for this trip was removed and can’t be turned on again.',
  'travel.publication.section.status.UNPUBLISHED': 'Sharing is stopped for this trip.',
  'travel.publication.section.status.DRAFT': 'Sharing setup isn’t finished.',
  'travel.publication.section.status.PUBLIC': 'This trip is public.',
  'travel.publication.section.status.PUBLISHED': 'This trip is published but not visible to everyone yet.',
  'travel.publication.section.visibility.notSet': 'Audience not set',
  'travel.publication.section.visibility.unknown': 'Audience can’t be determined',
  'travel.publication.section.visibility.current': 'Visible to: {label}',
  'travel.publication.section.visibility.label.PRIVATE': 'Only me',
  'travel.publication.section.visibility.label.FOLLOWERS': 'Followers',
  'travel.publication.section.visibility.label.PUBLIC': 'Everyone',
  'travel.publication.section.action.MAKE_PUBLIC': 'Make public',
  'travel.publication.section.action.REPUBLISH': 'Make public again',
  'travel.publication.section.action.SET_PUBLIC': 'Set to public',
  'travel.publication.section.action.UNPUBLISH': 'Stop sharing',
  'travel.publication.section.confirmAction.MAKE_PUBLIC': 'Yes, make public',
  'travel.publication.section.confirmAction.REPUBLISH': 'Yes, make public again',
  'travel.publication.section.confirmAction.SET_PUBLIC': 'Yes, set to public',
  'travel.publication.section.confirmAction.UNPUBLISH': 'Yes, stop sharing',
  'travel.publication.section.confirm.publish.title': 'Publish this trip?',
  'travel.publication.section.confirm.publish.body': 'Once published, travelers in the chosen audience can view this trip.',
  'travel.publication.section.confirm.republish.title': 'Publish this trip again?',
  'travel.publication.section.confirm.republish.body': 'Others will see the latest version you’re editing.',
  'travel.publication.section.confirm.unpublish.title': 'Stop sharing?',
  'travel.publication.section.cancelledHint': 'Cancelled trips can’t be made public.',
  'travel.publication.section.error.not-found': 'Sharing settings couldn’t be found.',
  'travel.publication.section.error.journey-not-found': 'This trip couldn’t be found.',
  'travel.publication.section.error.forbidden': 'You don’t have permission to change this trip’s sharing settings.',
  'travel.publication.section.error.conflict': 'Sharing settings just changed. The latest status has been reloaded.',
  'travel.publication.section.error.already-exists': 'This trip already has sharing settings. The latest status has been reloaded.',
  'travel.publication.section.error.lifecycle-not-writable': 'Sharing can’t be changed in the trip’s current status.',
  'travel.publication.section.error.invalid-lifecycle': 'This action isn’t available in the current sharing status.',
  'travel.publication.section.error.ownership-drift': 'The trip owner changed. Please refresh and try again.',
  'travel.publication.section.error.day-missing-place': 'Every day needs at least one valid place before sharing. Add places to the missing days first.',
  'travel.publication.section.error.validation': 'The sharing details aren’t valid.',
  'travel.publication.section.error.generic': 'Sharing settings couldn’t be completed right now.',
  'travel.publication.refresh.unchanged': 'The public version is up to date',
  'travel.publication.refresh.changed': 'You have changes that aren’t public yet',
  'travel.publication.refresh.changedHint': 'The public page still shows the last published version.',
  'travel.publication.refresh.unknown': 'There’s no baseline for the public version yet. Update it to check what’s public.',
  'travel.publication.refresh.blocked': 'Some items need attention before the public version can be updated',
  'travel.publication.refresh.cta': 'Update public version',
  'travel.publication.refresh.ctaUnknown': 'Review and update public version',
  'travel.publication.refresh.view': 'View current public version',
  'travel.publication.refresh.viewUnavailable': 'The current sharing audience can’t open the public page',
  'travel.publication.refresh.dialogTitle': 'Update the public version?',
  'travel.publication.refresh.dialogPrevious': 'The public page currently shows the last published version.',
  'travel.publication.refresh.dialogNext': 'After updating, the public page will show the current trip.',
  'travel.publication.refresh.dialogLink': 'Shared public links and group trips keep the same link.',
  'travel.publication.refresh.dialogCopy': 'New copies and share cards will use the updated public version.',
  'travel.publication.refresh.dialogFailure': 'If the update fails, the current public version stays unchanged.',
  'travel.publication.refresh.cancel': 'Cancel',
  'travel.publication.refresh.pending': 'Updating the public version…',
  'travel.publication.refresh.successChanged': 'Public version updated',
  'travel.publication.refresh.successNoOp': 'The public version is up to date',
  'travel.publication.refresh.planningChanged': 'Your changes aren’t in the public version yet',
  'travel.publication.refresh.planningUnknown': 'It’s not yet confirmed whether the public content matches the current trip.',
  'travel.publication.refresh.manage': 'Go to sharing settings',
  'travel.publication.refresh.reason.day': 'A day doesn’t have a valid place yet',
  'travel.publication.refresh.reason.customLocation': 'A custom place can’t be made public right now',
  'travel.publication.refresh.reason.state': 'The trip status doesn’t allow updates',
  'travel.publication.refresh.reason.changed': 'The public version status has changed',
  'travel.publication.refresh.reason.reload': 'Please reload the latest data',
  'travel.publication.refresh.reason.generic': 'Some items need attention before the public version can be updated',
  'travel.publication.refresh.error.invalid': 'This update wasn’t valid. Please reload and try again.',
  'travel.publication.refresh.error.forbidden': 'You don’t have permission to update this trip’s public version',
  'travel.publication.refresh.error.notFound': 'No public version to update was found.',
  'travel.publication.refresh.error.stale': 'The trip was updated elsewhere. Please reload and try again',
  'travel.publication.refresh.error.lifecycle': 'The trip or public version can’t be updated in its current status',
  'travel.publication.refresh.error.concurrent': 'The public version is being updated. Please reload shortly',
  'travel.publication.refresh.error.day': 'Every day needs a valid place before the public version can be updated.',
  'travel.publication.refresh.error.customLocation': 'This trip has custom places that aren’t public. Make them public or choose other places first.',
  'travel.publication.refresh.error.eligibility': 'The current trip can’t be published to the public version yet.',
  'travel.publication.refresh.error.rate': 'Too many attempts. Please try again later',
  'travel.publication.refresh.error.generic': 'Couldn’t update the public version. The current public content is kept',
  'travel.publication.refresh.reload': 'Reload',
  'travel.publication.refresh.retry': 'Try again',
  'travel.publication.refresh.versionsMissing': 'Please reload the latest data',
  'travel.publication.unpublish.body': 'The public page will be unavailable for now, and shared cards may show as unavailable. Making it public again keeps the same link.',
};

export function getPublicationRefreshMessage(locale, key) {
  const normalized = String(locale || '').replace('-', '_');
  let pack = publicationRefreshMessagesZhTW;
  if (normalized === 'zh_CN') pack = publicationRefreshMessagesZhCN;
  else if (normalized === 'en_US') pack = publicationRefreshMessagesEnUS;
  return pack[key] || publicationRefreshMessagesZhTW[key] || key;
}
